
const messages = [
  {
    SM: {
      LOGIN: '로그인이 필요한 서비스입니다.<br>로그인 하시겠습니까?',
      LOGIN_BACK: '로그인이 필요한 서비스입니다.<br>로그인 하시겠습니까?<br>취소 시 이전 페이지로 이동합니다.',
      LOGIN_ADULT: '성인인증이 필요한 상품입니다.<br>로그인 하시겠습니까?',
      CERTIFY_ADULT: '성인인증이 필요한 상품입니다.<br>성인인증을 진행하시겠습니까?',
      CERTIFY_ADULT_EXPIRED: '성인인증이 만료되었습니다.<br>성인인증을 진행하시겠습니까?',
      DELETE_DELIVERY_CONFIRM: '배송지를 삭제하시겠습니까?',
      MAX_SAVE_DELIVERY: '저장 가능한 배송지 수는 최대 20개입니다.',
      DELETE_NOTIFY_CONFIRM: '삭제한 알림은 복구할 수 없습니다.<BR>알림을 삭제하시겠습니까?',
      NO_SEARCH_RESULT: '검색 결과가 없습니다.<BR>다른 키워드로 검색해보세요.',
      NO_SEARCH_STORE: '검색된 매장이 없습니다.',
      NO_USE_POINT_HISTORY: '포인트 적립 및 사용 내역이 없습니다.',
      NO_GIFT_POINT_HISTORY: '보내거나 받은 포인트 선물 내역이 없습니다.',
      NO_FAMILY_GET_POINT: '나의 다이소 멤버십 패밀리가 없습니다.<BR>패밀리 멤버를 모아 최대 2,500 다이소 포인트 받아가세요!',
      PAGE_NOT_FOUND: '페이지를 찾을 수 없습니다.',
      OUT_OF_SERVICE: '현재 서비스 접속이<BR>원활하지 않습니다.<BR><BR>계속 이 화면이 보인다면,<BR>고객센터(1566-6531)로 연락해 주세요.'
    },
    PD: {
      UNAVAILABLE: '상품 정보가 존재하지 않습니다.',
      CART_SUCCESS: '장바구니에 상품을 담았습니다.',
      CART_OPTION: '옵션이 있는 상품입니다.<br>상품 상세에서 옵션을 선택해주세요.',
      CART_QY_OPTION: '수량 옵션이 있는 상품입니다.<br>상품상세에서 수량 옵션을 선택해주세요.',
      NOTIFY_PD_CONFIRM: '판매알림 신청이 가능한 상품입니다.<br>상품상세에서 신청하시겠습니까?',
      SELECT_OPTION: '옵션을 선택해주세요.',
      CERTIFY_ADULT: '성인인증이 필요한 상품입니다.<br>성인인증을 진행하시겠습니까?',
      CERTIFY_ADULT_EXPIRED: '성인인증이 만료되었습니다.<br>성인인증을 진행하시겠습니까?',
      ALREADY_SELECT_OPTION: '이미 선택한 옵션입니다.',
      CART_PKUP: '픽업 매장 변경 시 재고가 달라질 수 있습니다.',
      ZZIM_SUCCESS: '상품을 찜했습니다.',
      ZZIM_CANCEL: '찜하기가 해제되었습니다.',
      NOTIFY_NEWPD_SUCCESS: '판매시작 알림이 신청되었습니다.',
      NOTIFY_NEWPD_CANCEL: '판매시작 알림이 취소되었습니다.',
      NOTIFY_RESTOCK_SUCCESS: '재입고 알림이 신청되었습니다. (알림방법:{ntcnParam}) 신청내역은 [마이페이지>재입고/판매시작 알림]에서 확인 가능합니다',
      NOTIFY_RESTOCK_CANCEL: '재입고 알림이 취소되었습니다.',
      MASS_CART_CONFIRM: '선택한 수량은 대량주문으로 구매 가능합니다. 대량주문 장바구니에 담으시겠습니까?<BR>(대량주문은 옵션 선택 불가합니다.)',
      DELETE_PD_CONFIRM: '상품을 삭제하시겠습니까?',
      DELETE_SEL_PD_CONFIRM: '선택한 상품을 삭제하시겠습니까?',
      DELETE_ZZIM_CONFIRM: '찜한 상품을 삭제하시겠습니까?',
      DELETE_RE_WRH_NTCN_PD_ERROR: '선택된 상품이 없습니다.<br>알림 해제할 상품을 선택해 주세요.',
      DELETE_PD_SUCCESS: '삭제되었습니다.',
      REVW_BNWD: '리뷰 내용에 금칙어가 포함되어 있습니다.',
      REVW_VALIDATE: '아직 답변하지 않은 항목이 남아있어요.',
      SAVE_REVW_CONFIRM: '수정한 리뷰를 등록하시겠습니까?',
      SAVE_REVW_SUCCESS: '리뷰 등록이 완료되었습니다.',
      STMT_REVW_CONFIRM: '이 리뷰를 신고하시겠습니까?',
      STMT_REVW_ACCEPTED: '리뷰 신고가 접수되었습니다.',
      MODIFY_REVW_CONFIRM: '리뷰를 수정하시겠습니까?',
      MODIFY_REVW_SUCCESS: '리뷰가 수정되었습니다.',
      DELETE_REVW_CONFIRM: '리뷰를 삭제시<br>복구 및 재작성이 불가능합니다.<br>정말 삭제하시겠습니까?',
      DELETE_REVW_SUCCESS: '리뷰가 삭제되었습니다.',
      SAVE_MB_RE_WRH_SEPT_SUCCESS: '알림 횟수 설정이 변경되었습니다.',
      SAVE_LTNG_NTCN_RECT_Y_SUCCESS: '알림 시간 설정이 변경되었습니다.',
      SAVE_LTNG_NTCN_RECT_N_SUCCESS: '알림 시간 설정이 변경되었습니다.',
      DELETE_RE_WRH_NTCN_PD_CONFIRM: '선택한 상품의 재입고 알림 신청을 해제하시겠습니까?',
      RESIZE_REVW_MD_VIDEO_IMG: '/xcdr/capture/ts=1/dims/resize/150/quality/90',
      RESIZE_REVW_MD_IMG: '/dims/resize/150/quality/90',
      RESIZE_REVW_SMALL_VIDEO_IMG: '/xcdr/capture/ts=1/dims/resize/200/quality/90',
      RESIZE_REVW_SMALL_IMG: '/dims/resize/200/quality/90',
      RESIZE_REVW_LARGE_VIDEO_IMG: '/xcdr/capture/ts=1/dims/resize/600/quality/90',
      RESIZE_REVW_LARGE_IMG: '/dims/resize/600/quality/90',
      RESIZE_PROFILE: '/dims/autorotate/on/resize/^50x50/cropcenter/50x50/quality/100',
      RESIZE_REVW_VIDEO: '/xcdr/preset/_360p',
      RESIZE_CTEN_VIDEO: '/xcdr/capture/ts=1/dims/preset/_720p',
      APP_PD_GUIDE_MSG: '앱 전용 상품입니다.<br>앱에서 주문해주세요.',
      SIDEBAR_PD_THUB_IMG: '/dims/optimize/dims/autorotate/on/resizef/120x160',
      NOTIFY_ALREADY_RESTOCK: '이미 등록된 재입고 알림 신청 내역이 있습니다.',
      NOTIFY_RESTOCK_RQT_LIMIT: '재입고 알림 최대 신청수({param}개)가 초과되었습니다.',
      RESIZE_RESTOCK_IMG: '/dims/autorotate/on/dims/optimize/dims/resize/255x340',
      NOTIFY_RESTOCK_EXCEPT_PD: '해당 상품은 재입고 알림 기능을<br>제공하지 않습니다',
      STR_RE_WRH_NTCN_ONLY_MO: '매장 재입고 알림은 모바일을 통해서만<br> 신청 가능합니다. 앱을 다운로드 받은 후 재입고알림을 신청해 주세요. ',
      NOTIFY_OPENRUN_SUCCESS: '판매시작 알림 신청이 완료되었습니다. 신청내역은 [마이페이지>재입고/판매시작 알림]에서 확인 가능합니다.',
      NOTIFY_OPENRUN_CANCEL: '판매시작 알림 신청이 해지되었습니다.',
      DELETE_OP_RUN_NTCN_PD_CONFIRM: '선택한 상품의 판매시작 알림 신청을 해제하시겠습니까?',
      APP_PUSH_ONLY_APP: '앱 푸시 수신 설정은 다이소몰 앱에서만 가능해요. 다이소몰 앱을 열어 설정해 주세요.',
      RE_WRH_NTCN_TY_SAVED: '재입고알림 {ntcnTy} 수신 설정이 완료되었습니다.',

    },
    CM: {
      DELETE_BOARD_CONFIRM: '삭제한 게시글은 복구할 수 없습니다.<BR>게시글을 삭제하시겠습니까?',
      DELETE_BOARD_SUCCESS: '게시글이 삭제되었습니다.',
      COPY_ADDRESS: '주소가 복사되었습니다.',
      STMT_ACCEPTED: '신고가 접수되었습니다.',
      WRITE_REQUIRED_FORM: '필수 항목을 모두 입력해 주세요.',
      MOVE_PAGE_NO_SAVE_CONFIRM: '편집 중인 내용이 저장되지 않습니다.<BR>이동하시겠습니까?',
      CLOSE_LAYER_NO_SAVE_CONFIRM: '작성한 내용이 사라집니다.<br>레이어를 닫으시겠습니까?',
      SAVE_FAIL: '저장에 실패했습니다.'
    },
    DS: {
      DOWNLOAD_COUPON_SUCCESS: '쿠폰이 발급되었습니다.',
      DOWNLOAD_COUPON_FAIL: '이미 다운로드된 쿠폰입니다.',
      NORMAL_SUCCESS: '정상 처리되었습니다.',
      NORMAL_FAIL: '정상처리되지 않았습니다.',
      NTCN_SUCCESS: '알림 신청이 완료되었습니다.',
      NTCN_NO_TARGET: '알림 신청 대상이 아닙니다.',
      NTCN_ALREADY: '이미 알림 신청이 완료되었습니다.',
    },
    EV: {
      REG_COUPON_SUCCESS: '쿠폰이 등록되었습니다.',
      APPLY_COUPON_SUCCESS: '쿠폰이 적용되었습니다.',
      REG_PRF_CONFIRM: '프로필을 등록하고<BR>다이버에 지원해 보세요!'
    },
    OR: {
      NO_PD_CART: '장바구니에 담긴 상품이 없습니다.',
      EXCEED_PD_CART: '장바구니에 담을 수 있는<br>상품 개수를 초과했습니다.',
      FAIL_PD_CART: '장바구니 담기에 실패하였습니다.',
      CHANGE_PKUP_STORE_STCK_CONFIRM: '픽업 매장에 따라 재고가 달라질 수 있습니다. 픽업 매장을 변경하시겠습니까?',
      CHANGE_PKUP_STORE_CONFIRM: '픽업 매장 변경은 장바구니에서 가능합니다. 장바구니로 이동하시겠습니까?',
      CHANGE_DELIVERY_ADDR_CONFIRM: '배송지 변경은 장바구니에서 가능합니다. 장바구니로 이동하시겠습니까?',
      CHANGE_DELIVERY_ADDR_STCK_CONFIRM: '배송지 변경은 장바구니에서 가능합니다. 장바구니로 이동하시겠습니까?<BR>(배송지 변경 시 재고가 달라질 수 있습니다.)',
      CHANGE_DELIVERY_NEXT_CONFIRM: '변경된 배송지는 다음 정기배송일부터 반영됩니다.배송지를 변경하시겠습니까?',
      MASS_PKUP_ADDR_AUTO_SAVE: '대량주문 픽업 매장은 배송지 기준 자동 지정됩니다. 배송지 변경은 장바구니에서 가능합니다.',
      DELETE_PAY_CARD_CONFIRM: '등록된 카드 삭제 후 다른 카드를 등록하시겠습니까? 모든 정기배송 꾸러미의 결제수단이 변경됩니다.',
      NOT_AVAILABLE_APPLEPAY: '애플페이를 사용할 수 없는 기기입니다.<BR>다른 결제 수단을 이용해 주세요.',
      NOT_AVAILABLE_SSPAY: '삼성페이를 사용할 수 없는 기기입니다.<BR>다른 결제 수단을 이용해 주세요.',
      INC_UNORDERABLE_PD: '주문 불가 상품이 포함되어 있습니다.<BR>상품 제외 후 주문해 주세요.',
      AVAILABLE_MAKE_PACKAGE: '3만원 이상 주문시<BR>새로운 꾸러미를 만들 수 있습니다.',
      AVAILABLE_GIFT: '최소 1명 이상부터 선물할 수 있습니다.',
      AVAILABLE_GFCARD: '모바일 상품권은 최대 50만원까지 등록 가능합니다.',
      USED_GFCARD: '이미 사용된 상품권입니다.',
      NOT_AVAILABLE_GFCARD_KEY: '유효하지 않은 핀번호입니다.',
      COPY_GFCARD_KEY: '핀번호가 복사되었습니다.',
      EXPIRED_GFCARD: '사용 기간이 만료된 상품권입니다.',
      SAVE_GFCARD: '상품권이 저장되었습니다.',
      REFUSE_GFCARD_CONFIRM: '상품권 거절 시 다시 받기가 불가합니다.<BR>거절하시겠습니까?',
      RESEND_GFCARD: '등록한 번호로 상품권이 재전송되었습니다.',
      MAX_MAKE_PACKAGE: '꾸러미는 5개까지 만들 수 있습니다.',
      STOP_PACKAGE_CONFIRM: '해당 꾸러미를 일시정지 하시겠습니까?',
      COPY_ORDER_NUM: '주문번호가 복사되었습니다.',
      DELIVERY_PKUP_CART: '택배배송 장바구니로 이동했습니다.',
      DELETE_PD_ADD_DELIVERY_PAY_CONFIRM: '해당 상품 삭제 시 무료배송 기준 금액 부족으로 배송비가 부과됩니다. 삭제하시겠습니까?',
      DELETE_PD_STOP_DELIVERY_CONFIRM: '최소 구매 금액 미달 시 배송이 중지됩니다.<BR>삭제하시겠습니까?',
      MOVE_PKUP_CART: '매장픽업 장바구니로 이동했습니다.',
      CANCLE_ORDER_CONFIRM: '주문을 취소하시겠습니까?',
      CANCLE_PROMO_ADD_PAY_CONFIRM: '단순변심으로 반품 시 구매 혜택(배송비 할인, 쿠폰)이 취소되어 추가 결제가 필요합니다. 계속 진행하시겠습니까?',
      REFUND_ADD_PAY_CONFIRM: '환불 예정 금액이 회수 배송비보다 적어 추가 결제가 필요합니다. 계속 진행하시겠습니까?',
      GET_NOW_PAY_CONFIRM: '당겨받기를 신청할 경우 이번 정기배송 금액이 바로 결제됩니다. 당겨받기 하시겠습니까?,',
      CART_SUCCESS: '상품이 장바구니에 담겼습니다.',
      CART_FAIL: '장바구니 담기가 불가합니다.',
      SELECT_PD_MOVE_CART: '이동할 상품을 하나 이상 선택해 주세요.',
      OVER_COUNT_CART: '장바구니에 담을 수 있는<BR>상품 개수를 초과했습니다.',
      ALL_CART_SUCCESS: '전체 상품이 장바구니에 담겼습니다.<BR>(일시품절, 판매종료 상품 제외)',
      APPLY_MISSING_PD_PROCESS: '결품 시 처리 방법이 적용되었습니다.',
      APPLY_SECONDARY_PAY: '보조 결제 수단이 적용되었습니다.'
    },
    UG: {
      SCRAP_SUCCESS: '콘텐츠를 스크랩했습니다.',
      SCRAP_CANCEL: '스크랩을 해제했습니다.',
      COMMENT_SUCCESS: '댓글이 등록되었습니다.',
      NOTIFY_COMMENT_SUCCESS: '댓글 알림이 설정되었습니다.',
      NOTIFY_COMMENT_CANCEL: '댓글 알림이 해제되었습니다.',
      NOTIFY_LONG_CONT_SUCCESS: '긴글 알림이 설정되었습니다.',
      NOTIFY_LONG_CONT_CANCEL: '긴글 알림이 해제되었습니다.',
      NOTIFY_CREW_SUCCESS: '다이버 알림이 설정되었습니다.',
      NOTIFY_CREW_CANCEL: '다이버 알림이 해제되었습니다.',
      MODIFY_LONG_CONT_CONFIRM: '긴글 수정 시 관리자 승인 후 콘텐츠가 노출됩니다. 콘텐츠를 수정하시겠습니까?',
      MODIFY_CONT_CONFIRM: '콘텐츠 수정시 재승인 심사 기간이 발생합니다. 콘텐츠를 수정하시겠습니까?',
      DELETE_CONT_CONFIRM: '삭제한 콘텐츠는 복구할 수 없습니다.<BR>콘텐츠를 삭제하시겠습니까?',
      SAVE_SUCCESS: '정상적으로 저장되었습니다.',
      SAVE_FAIL: '저장에 실패했습니다.',
      TEMP_SAVE_SUCCESS: '임시저장 되었습니다.',
      TEMP_SAVE_FAIL: '임시저장에 실패했습니다.',
      DELETE_TEMP_CONT_CONFIRM: '임시 저장된 콘텐츠를 삭제하시겠습니까?',
      DELETE_PHOTO_CONFIRM: '사진 삭제 시, 태그한 상품도 함께 삭제됩니다.<BR>사진을 삭제하시겠습니까?',
      DELETE_PHOTO_CONFIRM2: '삭제 시 태그된 상품도 함께 사라집니다.<BR>등록한 사진을 삭제하시겠습니까?',
      DELETE_VIDEO_CONFIRM: '삭제 시 태그된 상품도 함께 사라집니다.<BR>등록한 영상을 삭제하시겠습니까?',
      SAVE_WRITE_CONT_CONFIRM: '작성한 콘텐츠를 등록 하시겠습니까?',
      DELETE_WRITE_CONT_CONFIRM: '작성 중인 콘텐츠를 삭제하시겠습니까?',
      ALREADY_TAGGED_PD: '이미 태그된 상품입니다.',
      SELECT_TAGGING_PD: '상품 태그하기 버튼을 눌러 소개할 상품을 선택해 보세요.',
      SELECT_TAGGING_LOC_PD: '상품을 태그하고 싶은 위치를 선택하세요.',
      MAX_TAGGING_PD: '상품은 한 이미지당 최대 7개까지 태그 가능합니다.',
      CANCEL_TAGGING_PD_CONFIRM: '상품 태그를 취소하시겠습니까?',
      DELETE_TAGGING_PD_CONFIRM: '태그한 상품이 사라집니다.<BR>상품 태그를 취소하시겠습니까?',
      DELETE_ZZIM_CONFIRM: '찜한 콘텐츠를 삭제하시겠습니까?',
      SHARE_DES: '한층 풍요로워지는 다이소 라이프를 만나보세요.',
      COMMENT_LIKE_Y: '좋아요 한 댓글입니다.',
      COMMENT_LIKE_N: '좋아요를 취소했습니다.',
      CONTENTS_LIKE_Y: '좋아요 한 게시물입니다.',
      CONTENTS_LIKE_N: '좋아요를 취소했습니다.',
      REG_PROFILE: '서비스 이용을 위해 프로필을 등록해 주세요.',
      REG_PROFILE_FOR_LIKE: '프로필을 등록하고<br>좋아요를 눌러보세요!',
      REG_PROFILE_FOR_SCRAP: '프로필을 등록하고<br>스크랩을 눌러보세요!',
      MODIFY_CONT_CCONFIRM: '작성한 콘텐츠를 수정하시겠습니까?',
      TAG_PD_INPUT: '상품의 품명 또는 품번을 입력해 주세요',
      AGREE_CHECK: '서비스 이용을 위해 필수 사항에 동의해 주세요.',
      PD_TAG_MIN: '상품태그는 최소 1개 이상 태그해 주십시요.',
      IMG_UPLOADING: '이미지 로딩중입니다. 다시 클릭해주세요.',
      RESIZE_LONG_THUMB: '/dims/autorotate/on/resize/1064x',
      RESIZE_SHORT_THUMB: '/dims/autorotate/on/resize/^585x780/cropcenter/585x780',
      RESIZE_LIST: '/dims/autorotate/on/resize/^300x400/cropcenter/300x400',
      RESIZE_PROFILE: '/dims/autorotate/on/resize/^100x100/cropcenter/100x100/quality/100',
      RESIZE_VIDEO: '/xcdr/trim/1-5/preset/_480p',
      RESIZE_PD_THUMB: '/dims/autorotate/on/resize/^140x186/cropcenter/140x186',
      ANLZ: '/xcdr/analyze/srcd'
    },
    MB: {
      CERT_KEY: '인증 번호가 발송되었습니다.',
      AGREE_REQUIRED_TERMS: '필수 약관에 동의해 주세요.',
      AGREE_PRIVACY_TERMS: '개인정보 수집 및 이용에 동의해 주세요.',
      LINK_SNS: '연동된 SNS 정보가 없습니다.<BR>회원가입 후 SNS를 연동해주세요.',
      AGREE_CONFIRM: '미리 동의하시면 새로운 다이소몰을 불편 없이 이용 가능합니다. 다음 번에 동의하시겠습니까?',
      LOGOUT_AGREE_CONFIRM: '동의하지 않을 경우 다이소몰 서비스 이용이 제한될 수 있습니다. 로그아웃 하시겠습니까?',
      DELETE_INQUIRY_CONFIRM: '삭제한 문의는 복구할 수 없습니다.<BR>문의를 삭제하시겠습니까?',
      STOP_INQUIRY_CONFIRM: '작성한 내용이 사라집니다.<BR>문의 작성을 중단하시겠습니까?',
      CANCLE_INQUIRY_CONFIRM: '작성한 내용은 저장되지 않습니다.<BR>등록 취소 후 페이지를 나가겠습니까?',
      SAVE_INQUIRY_CONFIRM: '문의사항을 등록 하시겠습니까?',
      SAVE_INQUIRY_SUCCESS: '문의 사항이 등록되었습니다.',
      THANKS_OPINION: '소중한 의견 감사합니다.',
      SEND_CERT_KEY_EMAIL: '이메일로 인증 번호가 발송되었습니다.',
      MODIFY_EMAIL: '이메일 주소가 수정되었습니다.',
      NOT_AVAILABLE_ACCOUNT: '유효하지 않은 계좌입니다.',
      CONFIRMED_ACCOUNT: '계좌 인증에 성공했습니다.',
      SAVE_RETURN_ACCOUNT: '환불 계좌 정보가 저장되었습니다.',

      NO_RCMDR_ID: '입력하신 ID가 존재하지 않습니다. 다시 확인해 주세요.',
      USED_ID: '이미 사용 중인 아이디입니다.<br>다른 아이디를 입력해주세요.',
      USED_EMAIL: '이미 사용 중인 이메일입니다.<br>다른 이메일을 입력해주세요.',
      CONFIRMED: '인증되었습니다.',

      LOGIN_FAIL: '일시적인 시스템 오류로 로그인에 실패하였습니다. 다시 시도해주시기 바랍니다. 불편을 드려 죄송합니다.',
      IS_UNDER_14_SNS_NOT_ALLOWED: '14세 미만일 경우 SNS 로그인 연결을 할 수 없습니다. 다이소몰 계정으로 로그인하시거나 ‘14세 미만 회원가입’을 진행해주세요.',
      INVALID_CI: '본인인증 정보가 일치하지 않습니다. 이름 또는 휴대폰번호가 변경된 경우 [고객센터 > 문의하기]에 문의 남겨주시면 빠르게 조치해 드리겠습니다.',
      VALID_CI_INFO_UPDATED: '본인인증이 완료되어 기본 정보가 자동 업데이트 되었습니다. 이제 개인정보 전체 확인이 가능합니다.',
      INVALID_CI_INFO_NOT_UPDATABLE: '본인인증 정보가 달라 기본정보 확인 및 변경이 불가합니다. 본인 명의로 인증을 진행해 주세요.<br><br>※ 본인 명의로 인증을 진행했음에도 본 안내창이 뜨는 경우, 고객센터 1:1문의에 글을 남겨주시기 바랍니다.',
      INVALID_CI_PW_NOT_UPDATABLE: '본인인증 정보가 달라 비밀번호를 변경할 수 없습니다. 본인 명의로 인증을 진행해 주세요.<br><br>※ 본인 명의로 인증을 진행했음에도 본 안내창이 뜨는 경우, 1:1문의를 남겨주시기 바랍니다. ',
      DELETE_GENDER_CONFIRM: '성별 정보를 삭제하시겠습니까? 성별을 다시 입력하시려면 본인인증을 진행해야 합니다.',
      CERTIFY_GENDER_CONFIRM: '성별 정보 확인을 위해 본인인증을 진행하시겠습니까? 본인인증 후 기본 정보가 자동 업데이트 됩니다.',
      UNMASK_MB_INFO_CONFIRM: '개인정보 전체 확인을 위해서는 본인인증이 필요합니다. 본인인증을 진행하시겠습니까?<br><br>※ 본인인증 후 기본정보가 자동 업데이트 됩니다.',
    }

  }
]

export default {
  ko: Object.assign(...messages)
}
